<script setup lang="ts">
import FloatingPopupLayout from '../FloatingPopupLayout.vue';
import PopupListElement from '../popupListElement/PopupListElement.vue';
import { type Props, type Emit, setup } from './myInfoPopupLanguageList.setup';

const props = defineProps<Props>();
const emit = defineEmits<Emit>();

const {
  t,

  onClickLanguageItem,
} = setup(emit);
</script>

<template>
  <floating-popup-layout
    class="my-info-language-list"
    :title="t('WORD.LANGUAGE')"
  >
    <template #list>
      <popup-list-element
        v-for="language in props.languageList"
        :key="language.value"
        :text="language.name"
        :selected="language.name === props.selectedLanguage"
        @click="() => onClickLanguageItem(language)"
      />
    </template>
  </floating-popup-layout>
</template>

<style scoped lang="scss">
.my-info-language-list {
  display: none !important;
  position: absolute;
  left: calc(var(--popup-wrapper-padding) + var(--popup-width)) !important;
  width: var(--gnb-sub-menu-width);
  padding: 0;

  &::before {
    position: absolute;
    top: 0;
    right: 100%;
    width: var(--popup-wrapper-padding);
    height: 100%;
    content: '';
  }

  &.shown {
    display: block !important;
  }

  :deep(.button-left) {
    span {
      font-size: 12px;

      @include shortening();
    }
  }
}
</style>
